import api from "./apiWithAccessToken";

export const getPlatformSmtpConfig = () => api.get("/platform/smtp-config");

export const savePlatformSmtpConfig = (data) =>
  api.post("/platform/smtp-config", data);
